<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-card class="elevation-2 card-empty">
        <v-app-bar color="primary accent-4" dense dark elevation="0">
          <v-toolbar-title> <v-icon left color="white">mdi-doctor</v-icon> SEND DOCTOR REGISTRATION CODES</v-toolbar-title>
        </v-app-bar>
        <v-card-text class="bg-white">
          <v-select
            class="mt-8"
            :rules="[(v) => !!v || 'This field is required']"
            :items="amountCodesOptions"
            outlined
            label="Amount of Codes"
            v-model="selectedAmountCodes"
          ></v-select>

          <!-- test type -->
          <TestTypesCheckboxSelection @testTypeSelected="testTypeSelectedParent" :defaultSelection="'1'" />

          <div class="d-flex">
            <v-spacer></v-spacer>
            <DoctorCodesDialog :doctors="selected" :selectedAmountCodes="selectedAmountCodes" :allowedTestTypes="allowedTestTypes" />
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card elevation="2">
        <v-card-title>
          Selected Doctors
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          height="600"
          v-model="selected"
          :headers="headers"
          :items="doctors"
          item-key="name"
          :search="search"
          show-select
          class="elevation-0"
          hide-default-footer
          :options="{ itemsPerPage: doctors.length }"
        >
        <template v-slot:item.url="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <div v-on="on" @click="openURL(item.url)">
                <img class="logo" :src="require('@/assets/images/generic/metabase.svg')" style="width: 20px; cursor:pointer;" />
                <!-- Status -->
              </div>
            </template>
            <span>View code status in Metabase.</span>
          </v-tooltip>
        </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import DoctorCodesDialog from '@/views/DoctorCodesPage/components/doctor-codes-dialog.vue';
import TestTypesCheckboxSelection from '@/components/test-types/test-types-checkbox-selection.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    DoctorCodesDialog,
    TestTypesCheckboxSelection
  },
  data() {
    return {
      search: '',
      selected: [],
      doctors: [],
      amountCodesOptions: [5, 10, 15, 20, 25, 30],
      selectedAmountCodes: 5,
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Email',
          align: 'start',
          sortable: false,
          value: 'email'
        },
        {
          text: 'Code Satus',
          align: 'start',
          sortable: false,
          value: 'url',
          width: "18%"// col-width
        }
      ],
      testTypes: ['1'],
      allowedTestTypes: []
    };
  },
  computed: {
    doctorOptions() {
      return this.getDoctorOptions; //this.$store.state.config.doctorOptions;
    },
    ...mapGetters('doctorOptionsStore', ['getDoctorOptions'])
  },
  watch: {
    doctorOptions: {
      handler(n) {
        if (n) {
          this.doctors = n.map((doctor) => {
            return {
              name: doctor.text,
              id: doctor.value,
              email: doctor.email,
              url: doctor.url
            };
          });
          this.selected = this.doctors;
        }
      },
      immediate: true
    }
  },
  created() {
    if (this.doctorOptions.length == 0) this.fetchDoctorOptions(); // this.$store.dispatch('doctorOptionsStore/fetchDoctorOptions');
  },
  methods: {
    openURL(url)
    {
      window.open(url, '_blank');
    },
    testTypeSelectedParent(testTypes) {
      if (testTypes.length > 0) this.allowedTestTypes = testTypes;
      else this.allowedTestTypes = [];
    },
    ...mapActions('doctorOptionsStore', ['fetchDoctorOptions'])
  }
};
</script>